// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimAdjudicationResponse {
    static getAttributeTypeMap() {
        return ClaimAdjudicationResponse.attributeTypeMap;
    }
}
ClaimAdjudicationResponse.discriminator = undefined;
ClaimAdjudicationResponse.attributeTypeMap = [
    {
        "name": "wasPreviouslyAdjudicated",
        "baseName": "wasPreviouslyAdjudicated",
        "type": "boolean"
    },
    {
        "name": "lineItems",
        "baseName": "lineItems",
        "type": "Array<ClaimAdjudicationResponseLineItem>"
    }
];
//# sourceMappingURL=claimAdjudicationResponse.js.map